module.exports = __webpack_public_path__ + "img/messages.95f7ad10.svg";